<template>
  <v-layout wrap align-center>
    <v-flex xs10>
      <template v-if="$vuetify.breakpoint.smAndDown">
        <div class="caption">{{title}} № {{id}}</div>
        <div class="caption grey--text">{{format(new Date(created_on), 'DD.MM.YYYY')}}</div>
      </template>
            <span class="title" v-else>
              {{title}} № {{id}} от {{format(new Date(created_on), 'DD.MM.YYYY')}}
            </span>
    </v-flex>
    <v-flex xs2 class="text-xs-right">
      <v-tooltip bottom>
        <v-btn
          slot="activator"
          @click="$router.go(-1)"
          color="grey"
          dark
          icon>
          <v-icon>mdi-close</v-icon>
        </v-btn>
        <span>Закрыть</span>
      </v-tooltip>
    </v-flex>
  </v-layout>
</template>

<script>
import { format } from 'date-fns'
export default {
  name: 'BalanceDocumentToolbar',
  props: {
    title: {
      default: '',
      required: true,
      type: String
    },
    created_on: {
      default: '',
      required: true,
      type: String
    },
    id: {
      default: '',
      required: true,
      type: String
    },
    name: {
      default: '',
      required: true,
      type: String
    }
  },
  data () {
    return {
      format
    }
  }
}
</script>

<style scoped>

</style>
